module.exports = __webpack_public_path__ + "img/Group 4064.493254d1.png";